import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "posts-toolbar bg-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangePickerBtn = _resolveComponent("DateRangePickerBtn")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_MediaFilter = _resolveComponent("MediaFilter")!
  const _component_PostsPlatformToolbar = _resolveComponent("PostsPlatformToolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_q_btn_group, { rounded: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_DateRangePickerBtn, {
            label: "Filter by Date",
            "model-value": _ctx.dateRange,
            rounded: "",
            "onUpdate:modelValue": _ctx.selectDateRange
          }, null, 8, ["model-value", "onUpdate:modelValue"]),
          (_ctx.dateRange)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                icon: "fa fa-times",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearDateRange()))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_MediaFilter, {
      "model-value": _ctx.filters.mediaTypes,
      rounded: "",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:filters', {..._ctx.filters, mediaTypes: $event})))
    }, null, 8, ["model-value"]),
    _createVNode(_component_PostsPlatformToolbar, {
      "category-ids": _ctx.filters.categoryIds,
      "lifecycle-statuses": _ctx.filters.lifecycleStatuses,
      onChange: _ctx.onCategoriesChange,
      onLifecycleChange: _ctx.onLifecycleChange
    }, null, 8, ["category-ids", "lifecycle-statuses", "onChange", "onLifecycleChange"]),
    _renderSlot(_ctx.$slots, "append")
  ]))
}